import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "clarwash_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, date: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] animate-fade-up px-4 pb-4 sm:px-6"
      data-testid="cookie-consent-banner"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-slate-200 bg-white/95 p-5 shadow-2xl backdrop-blur sm:flex-row sm:items-center sm:gap-6 sm:p-6">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Cookie className="h-6 w-6" />
        </span>
        <div className="flex-1">
          <p className="text-sm font-semibold text-slate-900">Folosim cookie-uri</p>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            Utilizăm cookie-uri strict necesare pentru funcționarea site-ului (coș, sesiune) și
            cookie-uri funcționale pentru o experiență mai bună. Detalii în{" "}
            <Link
              to="/politica-cookies"
              className="font-medium text-primary underline underline-offset-2 hover:text-primary/80"
              data-testid="cookie-policy-link"
            >
              Politica de cookie-uri
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            className="rounded-full border-slate-300 text-slate-600 hover:border-primary hover:text-primary"
            onClick={() => decide("necessary")}
            data-testid="cookie-necessary-btn"
          >
            Doar necesare
          </Button>
          <Button
            className="rounded-full hover:bg-primary/90"
            onClick={() => decide("all")}
            data-testid="cookie-accept-btn"
          >
            Accept toate
          </Button>
        </div>
        <button
          onClick={() => decide("necessary")}
          className="absolute right-3 top-3 text-slate-400 hover:text-slate-700 sm:hidden"
          aria-label="Închide"
          data-testid="cookie-close-btn"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
